import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import RoomTypeTranslationGenerated from './RoomTypeTranslation.generated';
import RoomTypeTranslation from '../RoomTypeTranslation';


export class RoomTypeGeneratedEntityManager<BT extends RoomTypeTranslationGenerated, B extends RoomTypeGenerated<BT>> extends EntityWithTranslationManager<BT, B>
{
	translationEntityClass: any = RoomTypeTranslation;

    constructor(parameters: EntityWithTranslationManagerParameters<BT, B>)
    {
        super({
            name: parameters.name ?? 'RoomType',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'code', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'isActive', type: BusinessEntityFieldType.Boolean },
				{ name: 'virtualTourUrl', type: BusinessEntityFieldType.VarChar },
				{ name: 'orderNo', type: BusinessEntityFieldType.Integer, isInput: false },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'roomTypes',
            translationsCustomGraphQlFields: 'name,description,descriptionExtra,seoTitle,seoDescription,seoKeywords,slug',
        });
    }

}
export class RoomTypeGenerated<BT extends RoomTypeTranslationGenerated> extends BusinessEntityWithTranslation<BT>
{
	/** The code of the room type (e.g., SGL, DBL, SUITE) */
	code!: string;
	/** Whether the room type is active and visible on the website */
	isActive: boolean = true;
	/** Relative URL to a 360° virtual tour of the room (e.g., /virtual-tours/tura/SGL) */
	virtualTourUrl: string = '';
	/** The order number of the entity. This is automatically set by the system. The value is updated automatically when the entity is moved up or down in the list. */
	orderNo: number = 0;
	/** The name of the foreign key to the translated entity. */
	translationForeignKeyName: string = 'roomType';
	/** The primary language of the entity. */
	primaryLanguage: string = 'ro';

}

export default RoomTypeGenerated;